import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TreeNavItem } from '../../../../models/tree-nav-item.model';
import { LauncherNavService } from '../../../../services/navigation/launcher-nav.service';
import { $userSearch } from '../../../../../../shared/constants/user';

@Component({
  selector: 'app-top-navbar-launcher-modal',
  templateUrl: './top-navbar-launcher-modal.component.html',
  styleUrls: ['./top-navbar-launcher-modal.component.scss'],
})
export class TopNavbarLauncherModalComponent implements OnInit, OnDestroy {
  public navItems$: Observable<TreeNavItem[]>;
  public form: FormGroup;
  public $userSearch: typeof $userSearch;
  private subscriptions: Subscription;

  constructor(
    private launcherNavService: LauncherNavService,
    private formBuilder: FormBuilder,
  ) {
    this.$userSearch = $userSearch;
    this.form = this.createSearchForm();
    this.subscriptions = new Subscription();
    this.navItems$ = this.launcherNavService.navItems$;
  }

  private createSearchForm(): FormGroup {
    return this.formBuilder.group({
      [$userSearch.searchTerm]: new FormControl<string>(null),
    });
  }

  private subscribeToSearch(): void {
    this.subscriptions.add(
      this.form.valueChanges.pipe(distinctUntilChanged()).subscribe((searchTerm: Record<string, any>) => {
        this.launcherNavService.setSearchQuery(searchTerm[$userSearch.searchTerm]);
      }),
    );

    this.subscriptions.add(
      this.launcherNavService.searchQuery$.pipe(distinctUntilChanged()).subscribe((value: string) => {
        if (this.form.get($userSearch.searchTerm).value !== value) {
          this.form.get($userSearch.searchTerm).setValue(value, { emitEvent: false });
        }
      }),
    );
  }

  protected onClose(): void {
    this.launcherNavService.setSearchQuery(null);
  }

  public ngOnInit(): void {
    this.subscribeToSearch();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
